// extracted by css-extract-rspack-plugin
export default {"reportViewer":"QJCGDWQEjpE7LuR7","reportFormat":"AUBW0owSH6ku3UZh","reportContent":"pjGJVjMaYwJxM0Is"};